import { FlowBlockState, type FlowOutputBlock, type FlowProducedType } from 'flow-schema';

import { Alert, Text, isDefined } from 'common';

import { useFlowRunContext } from '../../../../Runs/Run/contexts/flowRunContext.ts';
import { useReactFlowViewContext } from '../../../context/context.tsx';
import type { OutputContentProps } from '../../types';
import { DefaultReturnValueContent } from '../Default/OutputContent';

type OutputBlockConfig = FlowOutputBlock['config'];

export function OutputBlockOutputContent(props: OutputContentProps<FlowProducedType.Any>) {
  const { metadata, isFullHeightView } = props;
  const { selectedNodeId: outputBlockId } = useReactFlowViewContext();
  const { flowRun } = useFlowRunContext();

  if (!isDefined(outputBlockId)) {
    return <Alert>No output block found</Alert>;
  }

  const outputBlock = flowRun.data.blocks[outputBlockId];
  if (outputBlock.state !== FlowBlockState.Completed) {
    return <Text>No Output</Text>;
  }

  const outputBlockConfig = outputBlock.block.config as OutputBlockConfig;
  const sourceBlockName = outputBlockConfig.data;
  const sourceBlock = Object.values(flowRun.data.blocks).find(
    (block) => block.block.name === sourceBlockName
  );

  if (!isDefined(sourceBlock)) {
    return <Alert>No source block found, looking for {sourceBlockName}</Alert>;
  }

  if (!isDefined(sourceBlock.data)) {
    return <Text>No Output</Text>;
  }

  return (
    <DefaultReturnValueContent
      returnValue={sourceBlock.data}
      metadata={metadata}
      isFullHeightView={isFullHeightView}
    />
  );
}
